import { concat, EMPTY, from, timer } from "rxjs";
import { mapTo, switchMapTo, take } from "rxjs/operators";
import { click$ } from "../../../events/eventsBrowser";
import { selectIsModalOpen } from "../../../selectors/selectModalTabId";
import { actionModalCloseAll, actionModalOpen } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionShowMeConsumeBuildingInfoInInBuildMenu, actionShowMeSelectBuildingInfoInBuildMenu, } from "../actionShowMe";
import { selectBuildingCategoryType } from "../selectors/selectBuildingCategoryType";
export var createPathSelectBuildingInBuildMenu = function (getBuildingId) { return function (action, state$, deps) {
    var state = state$.value;
    var buildingId = getBuildingId(action, state$, deps);
    var isBuildMenuOpen = selectIsModalOpen(state, IdModal.BuildingList);
    var openBuildMenu$ = isBuildMenuOpen
        ? EMPTY
        : from([actionModalCloseAll(), actionModalOpen(IdModal.BuildingList)]);
    if (buildingId) {
        var tabId = parseInt(selectBuildingCategoryType(state, buildingId), 10);
        var selectBuildingInfo$ = from([
            actionShowMeSelectBuildingInfoInBuildMenu(tabId, buildingId),
        ]);
        return concat(selectBuildingInfo$, openBuildMenu$, 
        // It is only there because action$ is not present in paths to filter and listen to click
        timer(1).pipe(switchMapTo(click$.pipe(take(1), mapTo(actionShowMeConsumeBuildingInfoInInBuildMenu())))));
    }
    else {
        return openBuildMenu$;
    }
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/path/createPathSelectBuildingInBuildMenu.ts
// module id = 286
// module chunks = 3